const helpers = {
    capitalizeFirstLetter(str) {
        return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
    },
    formattingType(str) {
        if (str) {
            let arr = str.split("_");
            let capital = arr.map(
                (item, index) =>
                    item.charAt(0).toUpperCase() + item.slice(1).toLowerCase()
            );
            return capital.join(" ");
        } else return str;
    },
    moneyFormat(number, fixed = 2) {
        return parseFloat(number)
            .toFixed(fixed)
            .replace(/\d(?=(\d{3})+\.)/g, "$&,");
    },
    sliceAddress(address) {
        if (address) {
            return address.slice(0, 4) + "..." + address.slice(-8);
        } else return address;
    },
    getTokenUrl(network) {
        return this.$store.state.vaults.env.network[network].url;
    },
    generateVaultName(vault){
        if(vault.network === 'smartbch'){
            return vault.network;
        } else return vault.token;
    },
    generateGasLimit(network){
        if(network == 'boba') return "500000";
        else return "250000";
    },
    countDecimals(value) {
        return value.toString().split('0').length-1;
    },
    isNumber: function(evt) {
        evt = (evt) ? evt : window.event;
        var charCode = (evt.which) ? evt.which : evt.keyCode;
        if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
            evt.preventDefault();;
        } else {
            return true;
        }
    },
    toBaseUnit(value, base, BN) {
        // helper function to convert number strings to base value, keeping their precision

        if (!(typeof value === "string" || value instanceof String)) {
            throw new Error(
                "Pass strings to prevent floating point precision issues."
            );
        }

        // how many decimals
        const decimals = Math.log10(base);
        if (!decimals) {
            throw new Error("invalid base");
        }

        // Is it negative?
        let negative = value.substring(0, 1) === "-";
        if (negative) {
            value = value.substring(1);
        }

        if (value === ".") {
            throw new Error(
                `Invalid value ${value} cannot be converted to` +
                ` base unit with ${decimals} decimals.`
            );
        }

        // Split it into a whole and fractional part
        let comps = value.split(".");
        if (comps.length > 2) {
            throw new Error("Too many decimal points");
        }

        let whole = comps[0],
            fraction = comps[1];

        if (!whole) {
            whole = "0";
        }
        if (!fraction) {
            fraction = "0";
        }
        if (fraction.length > decimals) {
            throw new Error("Too many decimal places");
        }

        while (fraction.length < decimals) {
            fraction += "0";
        }

        whole = new BN(whole);
        fraction = new BN(fraction);
        let wei = whole.mul(base).add(fraction);

        if (negative) {
            wei = wei.neg();
        }

        return new BN(wei.toString(10), 10);
    },
};

export default helpers;
